import { Box, Flex, Text, useColorModeValue as mode } from "@chakra-ui/react";

const InvoiceRow = ({ number, date, time, total, index, header, selected, onSelect, onDouble }) => {
  return (
    <Flex
      bg={
        selected
          ? mode("blue.100", "blue.700")
          : index % 2 === 0
          ? mode("white", "gray.800")
          : mode("gray.100", "gray.700")
      }
      align='center'
      justify='start'
      borderBottom='1px solid'
      borderColor={mode("gray.200", "gray.600")}
      alignItems='stretch'
      onClick={() => {
        if (onSelect) onSelect(index);
      }}
      onDoubleClick={() => {
        if (onDouble) onDouble(index);
      }}
      cursor='pointer'
    >
      <Box
        flex='2  '
        borderRight='1px solid'
        borderColor={mode("gray.200", "gray.600")}
        onClick={() => {
          if (onDouble) onDouble(index);
        }}
      >
        <Text
          textAlign='left'
          fontWeight={header ? "bold" : "normal"}
          p={2}
          mt={0}
          textDecoration={header ? "none" : "underline"}
          textUnderlineOffset='2px'
        >
          {number}
        </Text>
      </Box>
      <Box flex='2' borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {date}
        </Text>
      </Box>
      <Box flex='2' borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {time}
        </Text>
      </Box>
      <Box flex='2' borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text flex='2' textAlign={header ? "left" : "right"} fontWeight={header ? "bold" : "normal"} p={1}>
          {total}
        </Text>
      </Box>
    </Flex>
  );
};

export default InvoiceRow;
